import React from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import Link from 'components/Link';
import breakpoint from 'styled-components-breakpoint';
import IconBusiness from './assets/icon-business.svg';
import IconMarketplace from './assets/icon-marketplace.svg';
import IconShop from './assets/icon-shop.svg';
import Button from './Button';
import LocaleCode from 'providers/LocaleCode';
import { isMobile } from 'react-device-detect';
import { BUSINESS_999_URL_PATHS } from '../../constants';
import { format999RedirectUrl } from '../../routes';
const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 19px;
  position: relative;

  &::before {
    content: '';
    width: 100%;
    height: 751px;
    background-color: #f8f8f8;
    position: absolute;
    z-index: -1;
    top: 169px;
    display: none;
  }

  ${breakpoint('desktop')`
    justify-content: center;
    flex-direction: row;

    &::before {
      display: block;
    }
  `};
`;

const Card = styled.div`
  border: 1px solid #dbdbdb;
  background-color: #fff;
  min-width: 305px;
  width: 305px;
  min-height: 320px;
  height: 320px;
  border-radius: 50px;
  padding: 18px 19px;
  box-sizing: border-box;
  &:not(:last-of-type) {
    margin-bottom: 50px;
  }

  ${breakpoint('desktop')`
    margin-bottom: 0 !important;
    &:not(:last-of-type) {
      margin-right: 20px;
    }
    transition: transform .1s ease;
    &:hover {
      transform: scale(1.02);
      box-shadow: 0px 38.6624px 54.6022px -8.4786px rgba(0, 0, 0, 0.21);
      border-color: #fff;

      & i:before {
        filter: brightness(0) saturate(100%) invert(28%) sepia(64%) saturate(5324%) hue-rotate(224deg) brightness(98%) contrast(95%);
      }
    }
  `};
`;

const Icon = styled.i`
  width: 83px;
  height: 80px;
  background: #f5f5f5;
  border-radius: 32px;
  display: block;
  position: relative;
  margin-bottom: 9px;

  &.icon-business {
    &:before {
      background-image: url(${IconBusiness});
    }
  }
  &.icon-marketplace {
    &:before {
      background-image: url(${IconMarketplace});
    }
  }
  &.icon-shop {
    &:before {
      background-image: url(${IconShop});
    }
  }

  &:before {
    content: '';
    background-repeat: no-repeat;
    background-size: cover;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-right: -50%;
    transform: translate(-50%, -50%);
    width: 38px;
    height: 38px;
  }
`;

const Title = styled.h3`
  font-weight: 700;
  font-size: 31px;
  line-height: 40px;
  color: #333333;
  margin-bottom: 5px;
  text-transform: uppercase;
  letter-spacing: -0.5px;
`;

const Subtitle = styled.p`
  font-weight: 400;
  font-size: 15;
  line-height: 20px;
  color: #333333;
  margin-bottom: 17px;
`;

const LabelWrapper = styled.div`
  margin-bottom: 19px;
`;

const Label = styled.label`
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.6px;
  text-align: center;
  color: #959595;
  background: #f5f5f5;
  border-radius: 22px;
  padding: 5px 11px;
  &:not(:last-of-type) {
    margin-right: 4px;
  }
`;

const ButtonWrapper = styled.div`
  & a:not(:last-of-type) {
    margin-right: 7px;
  }
`;
const ExternalLink = styled.a`
  color: rgba(60, 64, 66, 0.6);
  font-size: 13px;
  line-height: 15px;
  display: block;
  margin-bottom: 8px;
  display: inline-block;
`;
const BusinessCards = ({ subscriptionIsActive }) => {
  return (
    <LocaleCode>
      {() => (
        <Wrapper>
          <Card>
            <Icon className="icon-business" />
            <Title>Business</Title>
            <Subtitle>
              <FormattedMessage
                id="homeredesign.businesscards.subtitle1"
                defaultMessage="Расширенная аналитика 999 для больших продаж"
              />
            </Subtitle>
            <LabelWrapper>
              <Label>sales</Label>
              <Label>trends</Label>
              <Label>finance</Label>
            </LabelWrapper>
            <ButtonWrapper>
              <ExternalLink
                href={format999RedirectUrl(BUSINESS_999_URL_PATHS.TARIFFS)}
                target="_blank"
              >
                <Button
                  onClick={() => {
                    if (!subscriptionIsActive) {
                      /* GA event */
                      (window.dataLayer || []).push({
                        event: 'business_activate',
                        action: 'start',
                        location: 'business_999',
                        button_location: isMobile ? 'main_mobile' : 'terms',
                      });
                      window.dataLayerLocation = isMobile
                        ? 'main_mobile'
                        : 'main';
                    }
                  }}
                  className="hover-active"
                >
                  <FormattedMessage
                    id="homeredesign.businesscards.connect"
                    defaultMessage="Условия"
                  />
                </Button>
              </ExternalLink>
              <a href="#tariffs">
                <Button className="hover-active">
                  <FormattedMessage
                    id="homeredesign.businesscards.about"
                    defaultMessage="Подробнее"
                  />
                </Button>
              </a>
            </ButtonWrapper>
          </Card>
        </Wrapper>
      )}
    </LocaleCode>
  );
};

export default BusinessCards;
